import { useState } from 'react'
import _uniqueId from 'lodash/uniqueId'
import styles from './Select.module.scss'
import classNames from 'classnames'

type SelectProps = React.PropsWithChildren<{
  name?: string
  label?: string
  defaultValue?: string
  value?: string | null
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void
  disable?: boolean
  styleGrid?: boolean
}>

export const Select = ({
  label,
  children,
  defaultValue,
  value,
  onChange,
  disable,
  styleGrid,
}: SelectProps) => {
  const [id] = useState(_uniqueId('input-'))
  return (
    <div className={classNames('mb-2')}>
      {label && (
        <label htmlFor={id} className="label-small my-1">
          {label}
        </label>
      )}
      <select
        defaultValue={defaultValue}
        value={value ?? undefined}
        id={id}
        onChange={onChange}
        className={classNames(
          styles.select,
          styleGrid && styles.inGrid,
          'w-100'
        )}
        disabled={disable}
      >
        {children}
      </select>
    </div>
  )
}
